import { ru, en } from "../i18n.js";
const RU = {
  // — группы навигации —
  "m.g.dossier": "\u041B\u0438\u0447\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
  "m.g.property": "\u0418\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E",
  "m.g.tasks": "\u0417\u0430\u0434\u0430\u043D\u0438\u044F",
  "m.g.pass": "\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "m.g.anims": "\u0410\u043D\u0438\u043C\u0430\u0446\u0438\u0438",
  "m.g.shop": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  "m.g.games": "\u0420\u0430\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u044F",
  "m.g.society": "\u041E\u0431\u0449\u0435\u0441\u0442\u0432\u043E",
  "m.g.service": "\u0421\u0435\u0440\u0432\u0438\u0441",
  // — пункты навигации —
  "m.overview": "\u041E\u0431\u0437\u043E\u0440",
  "m.stats": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
  "m.skills": "\u041D\u0430\u0432\u044B\u043A\u0438",
  "m.vehicles": "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
  "m.storage": "\u0425\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435",
  "m.estate": "\u041D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C",
  "m.quests": "\u041A\u0432\u0435\u0441\u0442\u044B",
  "m.dailies": "\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0435",
  "m.bonuses": "\u0411\u043E\u043D\u0443\u0441\u044B",
  "m.battlepass": "\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "m.anims": "\u0410\u043D\u0438\u043C\u0430\u0446\u0438\u0438",
  "m.cases": "\u041A\u0435\u0439\u0441\u044B",
  "m.clothing": "\u041E\u0434\u0435\u0436\u0434\u0430",
  "m.shopcars": "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D",
  "m.currency": "\u0412\u0430\u043B\u044E\u0442\u0430",
  "m.premium": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C",
  "m.services": "\u0423\u0441\u043B\u0443\u0433\u0438",
  "m.starter": "\u041D\u0430\u0431\u043E\u0440\u044B",
  "m.wheel": "\u041A\u043E\u043B\u0435\u0441\u043E \u0443\u0434\u0430\u0447\u0438",
  "m.sapper": "\u0421\u0430\u043F\u0451\u0440",
  "m.business": "\u0411\u0438\u0437\u043D\u0435\u0441",
  "m.organization": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "m.achievements": "\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F",
  "m.reports": "\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
  "m.settings": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  "m.rules": "\u041F\u0440\u0430\u0432\u0438\u043B\u0430",
  // — оболочка —
  "m.close": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \xB7 F2",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.close": "Закрыть",
  "m.ov.faction": "Организация",
  "m.balance": "\u0411\u0430\u043B\u0430\u043D\u0441",
  "m.empty": "\u041F\u043E\u043A\u0430 \u043F\u0443\u0441\u0442\u043E",
  "m.buy": "\u041A\u0443\u043F\u0438\u0442\u044C",
  "m.take": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C",
  "m.taken": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
  "m.skipped": "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
  "m.locked": "\u0417\u0430\u043A\u0440\u044B\u0442\u043E",
  "m.price": "\u0426\u0435\u043D\u0430",
  "m.total": "\u0412\u0441\u0435\u0433\u043E",
  "m.of": "\u0438\u0437",
  "m.notEnough": "\u041D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 JC",
  "m.soon": "\u0421\u043A\u043E\u0440\u043E",
  "m.all": "\u0412\u0441\u0435",
  "m.search": "\u041F\u043E\u0438\u0441\u043A",
  "m.nothingFound": "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
  // — обзор —
  "m.ov.kicker": "\u041B\u0438\u0447\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
  "m.ov.title": "\u041E\u0431\u0437\u043E\u0440 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "m.ov.cash": "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
  "m.ov.bank": "\u041D\u0430 \u0441\u0447\u0451\u0442\u0435",
  "m.ov.age": "\u0412\u043E\u0437\u0440\u0430\u0441\u0442",
  "m.ov.gender": "\u041F\u043E\u043B",
  "m.ov.male": "\u041C\u0443\u0436\u0441\u043A\u043E\u0439",
  "m.ov.female": "\u0416\u0435\u043D\u0441\u043A\u0438\u0439",
  "m.ov.job": "\u0420\u0430\u0431\u043E\u0442\u0430",
  "m.ov.wedding": "\u0421\u0435\u043C\u0435\u0439\u043D\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
  "m.ov.single": "\u041D\u0435 \u0432 \u0431\u0440\u0430\u043A\u0435",
  "m.ov.fraction": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "m.ov.family": "\u0421\u0435\u043C\u044C\u044F",
  "m.ov.rank": "\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C",
  "m.ov.vip": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C \u0441\u0442\u0430\u0442\u0443\u0441",
  "m.ov.vipUntil": "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E",
  "m.ov.passport": "\u041F\u0430\u0441\u043F\u043E\u0440\u0442",
  "m.ov.phone": "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
  "m.ov.noSim": "\u041D\u0435\u0442 \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u044B",
  "m.ov.account": "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0451\u0442\u0430",
  "m.ov.docs": "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
  "m.ov.status": "\u041F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
  "m.ov.years": "\u043B\u0435\u0442",
  "m.ov.level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C",
  "m.ov.respect": "\u0420\u0435\u0441\u043F\u0435\u043A\u0442",
  "m.ov.next": "\u0427\u0442\u043E \u0434\u0430\u043B\u044C\u0448\u0435",
  "m.ov.watched": "\u041F\u043E\u0434 \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u0435\u043C",
  "m.ov.clean": "\u0420\u0435\u043F\u0443\u0442\u0430\u0446\u0438\u044F \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435",
  // — статистика —
  "m.st.kicker": "\u0423\u0447\u0451\u0442\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0430",
  "m.st.title": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
  "m.st.registered": "\u0412 \u0438\u0433\u0440\u0435 \u0441",
  "m.st.playtime": "\u0412\u0440\u0435\u043C\u044F \u0432 \u0438\u0433\u0440\u0435",
  "m.st.today": "\u0414\u0435\u043D\u044C",
  "m.st.month": "\u041C\u0435\u0441\u044F\u0446",
  "m.st.total": "\u0412\u0441\u0435\u0433\u043E",
  "m.st.warns": "\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F",
  "m.st.warnsActive": "\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0438\u0437 3",
  "m.st.licenses": "\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u0438",
  "m.st.has": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
  "m.st.hasNot": "\u041D\u0435\u0442",
  "m.st.licOf": "\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E {n} \u0438\u0437 {all}",
  // — навыки —
  "m.sk.kicker": "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u0438",
  "m.sk.title": "\u041D\u0430\u0432\u044B\u043A\u0438",
  "m.sk.rank": "\u0440\u0430\u043D\u0433",
  "m.sk.progress": "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441",
  "m.sk.maxed": "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
  "m.sk.none": "\u041D\u0430\u0432\u044B\u043A\u0438 \u0435\u0449\u0451 \u043D\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044B \u2014 \u0443\u0441\u0442\u0440\u043E\u0439\u0442\u0435\u0441\u044C \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443",
  // — транспорт —
  "m.veh.kicker": "\u0413\u0430\u0440\u0430\u0436",
  "m.veh.title": "\u041C\u043E\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
  "m.veh.plate": "\u041D\u043E\u043C\u0435\u0440",
  "m.veh.fuel": "\u0422\u043E\u043F\u043B\u0438\u0432\u043E",
  "m.veh.state": "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435",
  "m.veh.mileage": "\u041F\u0440\u043E\u0431\u0435\u0433",
  "m.veh.parking": "\u0421\u0442\u043E\u044F\u043D\u043A\u0430",
  "m.veh.garage": "\u0412 \u0433\u0430\u0440\u0430\u0436\u0435",
  "m.veh.street": "\u041D\u0430 \u0443\u043B\u0438\u0446\u0435",
  "m.veh.impound": "\u041D\u0430 \u0448\u0442\u0440\u0430\u0444\u0441\u0442\u043E\u044F\u043D\u043A\u0435",
  "m.veh.none": "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0435\u0442",
  "m.veh.locate": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
  // — хранилище —
  "m.stg.kicker": "\u0421\u043A\u043B\u0430\u0434 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "m.stg.title": "\u0425\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435",
  "m.stg.take": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C \u0432 \u0438\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u044C",
  "m.stg.slots": "\u0437\u0430\u043D\u044F\u0442\u043E \u044F\u0447\u0435\u0435\u043A",
  "m.stg.none": "\u0412 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u043F\u0443\u0441\u0442\u043E",
  "m.stg.count": "\u0448\u0442.",
  "m.stg.pickupHint": "\u0412\u0435\u0449\u0438 \u0432\u044B\u0434\u0430\u044E\u0442 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0435 \u2014 \u043F\u043E\u0434\u044A\u0435\u0437\u0436\u0430\u0439\u0442\u0435 \u043A \u0441\u0442\u043E\u0439\u043A\u0435 \u0432\u044B\u0434\u0430\u0447\u0438.",
  "m.stg.route": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u043A\u043B\u0430\u0434 \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
  "m.stg.point": "\u0421\u043A\u043B\u0430\u0434 \u043B\u0438\u0447\u043D\u044B\u0445 \u0432\u0435\u0449\u0435\u0439",
  "m.veh.evac": "\u042D\u0432\u0430\u043A\u0443\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0433\u0430\u0440\u0430\u0436",
  "m.veh.impound": "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0448\u0442\u0440\u0430\u0444\u0441\u0442\u043E\u044F\u043D\u043A\u0443",
  "m.veh.keys": "\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043A\u043B\u044E\u0447\u0438",
  // — недвижимость —
  "m.es.kicker": "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C",
  "m.es.title": "\u041D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C",
  "m.es.house": "\u0414\u043E\u043C",
  "m.es.biz": "\u0411\u0438\u0437\u043D\u0435\u0441",
  "m.es.warehouse": "\u0421\u043A\u043B\u0430\u0434",
  "m.es.safe": "\u0412 \u0441\u0435\u0439\u0444\u0435",
  "m.es.income": "\u0414\u043E\u0445\u043E\u0434 \u0432 \u0447\u0430\u0441",
  "m.es.slots": "\u041C\u0435\u0441\u0442 \u043F\u043E\u0434 \u0430\u0432\u0442\u043E",
  "m.es.tax": "\u041D\u0430\u043B\u043E\u0433 \u0434\u043E",
  "m.es.none": "\u0418\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430 \u043D\u0435\u0442",
  "m.es.addr": "\u0410\u0434\u0440\u0435\u0441",
  // — квесты —
  "m.ac.account": "\u0410\u043A\u043A\u0430\u0443\u043D\u0442",
  "m.ac.level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C",
  "m.ac.exp": "\u041E\u043F\u044B\u0442",
  "m.ac.daysOn": "\u041D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435",
  "m.ac.since": "\u0421 \u043D\u0430\u043C\u0438 \u0441",
  "m.ac.time": "\u0412\u0440\u0435\u043C\u044F \u0432 \u0438\u0433\u0440\u0435",
  "m.ac.today": "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
  "m.ac.month": "\u0417\u0430 \u043C\u0435\u0441\u044F\u0446",
  "m.ac.total": "\u0412\u0441\u0435\u0433\u043E",
  "m.ac.wealth": "\u0418\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E \u0438 \u0441\u0447\u0435\u0442\u0430",
  "m.ac.jc": "\u0411\u0430\u043B\u0430\u043D\u0441 JC",
  "m.ac.cars": "\u041C\u0430\u0448\u0438\u043D",
  "m.ac.house": "\u0414\u043E\u043C",
  "m.ac.biz": "\u0411\u0438\u0437\u043D\u0435\u0441\u043E\u0432",
  "m.ac.status": "\u0421\u0442\u0430\u0442\u0443\u0441\u044B",
  "m.ac.vip": "\u041F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u044F",
  "m.ac.until": "\u0434\u043E",
  "m.ac.sub": "\u041F\u043E\u0434\u043F\u0438\u0441\u043A\u0430",
  "m.ac.active": "\u0430\u043A\u0442\u0438\u0432\u043D\u0430",
  "m.ac.warns": "\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F",
  "m.ac.wanted": "\u0420\u043E\u0437\u044B\u0441\u043A",
  "m.ac.org": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "m.ac.wedding": "\u0411\u0440\u0430\u043A",
  "m.ac.no": "\u043D\u0435\u0442",
  "m.q.kicker": "\u0421\u044E\u0436\u0435\u0442",
  "m.q.title": "\u041A\u0432\u0435\u0441\u0442\u044B",
  "m.q.stage": "\u042D\u0442\u0430\u043F",
  "m.q.route": "\u041F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043C\u0430\u0440\u0448\u0440\u0443\u0442",
  "m.q.accept": "\u0412\u0437\u044F\u0442\u044C \u043A\u0432\u0435\u0441\u0442",
  "m.q.reward": "\u041D\u0430\u0433\u0440\u0430\u0434\u0430",
  "m.q.none": "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u043A\u0432\u0435\u0441\u0442\u043E\u0432 \u043D\u0435\u0442",
  "m.q.active": "\u0410\u043A\u0442\u0438\u0432\u0435\u043D",
  "m.q.next": "\u0414\u0430\u043B\u0435\u0435",
  "m.q.goals": "\u0426\u0435\u043B\u0438",
  "m.q.money": "\u0414\u0435\u043D\u044C\u0433\u0438",
  "m.q.items": "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u0432 \u043D\u0430\u0433\u0440\u0430\u0434\u0443",
  // — ежедневные —
  "m.d.kicker": "\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439 \u0432\u0445\u043E\u0434",
  "m.d.title": "\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
  "m.d.day": "\u0414\u0435\u043D\u044C {n}",
  "m.d.week": "\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043D\u0435\u0434\u0435\u043B\u0438",
  "m.d.in": "\u0427\u0435\u0440\u0435\u0437",
  "m.d.streak": "\u0414\u043D\u0435\u0439 \u043F\u043E\u0434\u0440\u044F\u0434",
  // — бонусы —
  "m.b.kicker": "\u0417\u0430 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435",
  "m.b.title": "\u0411\u043E\u043D\u0443\u0441\u044B",
  "m.b.progress": "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u043E {a} \u0438\u0437 {b} JC",
  // — боевой пропуск —
  "m.bp.kicker": "\u0421\u0435\u0437\u043E\u043D",
  "m.bp.title": "\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "m.bp.level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C {n}",
  "m.bp.free": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
  "m.bp.prem": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C",
  "m.bp.buyPrem": "\u041A\u0443\u043F\u0438\u0442\u044C \u043F\u0440\u0435\u043C\u0438\u0443\u043C",
  "m.bp.premOn": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C \u0430\u043A\u0442\u0438\u0432\u0435\u043D",
  "m.bp.daysLeft": "\u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C {n} \u0434\u043D.",
  "m.bp.track": "\u0414\u043E\u0440\u043E\u0436\u043A\u0430 \u043D\u0430\u0433\u0440\u0430\u0434",
  "m.bp.buyExp": "\u041A\u0443\u043F\u0438\u0442\u044C \u043E\u043F\u044B\u0442",
  "m.bp.tasks": "\u0417\u0430\u0434\u0430\u043D\u0438\u044F \u0441\u0435\u0437\u043E\u043D\u0430",
  "m.bp.daily": "\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0435",
  "m.bp.weekly": "\u041D\u0435\u0434\u0435\u043B\u044C\u043D\u044B\u0435",
  "m.bp.season": "\u0421\u0435\u0437\u043E\u043D\u043D\u044B\u0435",
  "m.bp.done": "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E",
  "m.bp.progress": "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441",
  "m.bp.takeAll": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0451",
  "m.bp.levels": "\u0423\u0440\u043E\u0432\u043D\u0438 {a}\u2013{b}",
  "m.bp.toCurrent": "\u041A \u043C\u043E\u0435\u043C\u0443 \u0443\u0440\u043E\u0432\u043D\u044E",
  "m.bp.week": "\u041D\u0435\u0434\u0435\u043B\u044F",
  "m.bp.weekN": "\u041D\u0435\u0434\u0435\u043B\u044F {n}",
  "m.bp.now": "\u0418\u0434\u0451\u0442 \u0441\u0435\u0439\u0447\u0430\u0441",
  "m.bp.tiers": "\u041F\u0440\u043E\u0439\u0434\u0435\u043D\u043E \u0443\u0440\u043E\u0432\u043D\u0435\u0439",
  "m.bp.spTotal": "\u0412\u0441\u0435\u0433\u043E SP",
  "m.bp.noReward": "\u0411\u0435\u0437 \u043D\u0430\u0433\u0440\u0430\u0434\u044B",
  "m.bp.noTasks": "\u0417\u0430\u0434\u0430\u043D\u0438\u0439 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442",
  "m.bp.premAbout": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043B\u0438\u043D\u0438\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0430 \u0432\u0441\u0435\u043C. \u041F\u0440\u0435\u043C\u0438\u0443\u043C \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u0442\u043E\u0440\u0443\u044E \u043B\u0438\u043D\u0438\u044E \u043D\u0430\u0433\u0440\u0430\u0434 \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u0443\u0440\u043E\u0432\u043D\u0435 \u2014 \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u0442\u0441\u044F \u043E\u0434\u0438\u043D \u0440\u0430\u0437 \u043D\u0430 \u0432\u0435\u0441\u044C \u0441\u0435\u0437\u043E\u043D \u0438 \u043D\u0435 \u0441\u0433\u043E\u0440\u0430\u0435\u0442.",
  "m.bp.starterPass": "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "m.bp.premPass": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C-\u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "m.bp.yours": "\u0423\u0436\u0435 \u0443 \u0432\u0430\u0441",
  "m.bp.included": "\u0412\u0445\u043E\u0434\u0438\u0442 \u0432 \u043F\u0440\u0435\u043C\u0438\u0443\u043C",
  "m.bp.free1": "\u0412\u0435\u0440\u0445\u043D\u044F\u044F \u043B\u0438\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434 \u0437\u0430 \u043E\u0447\u043A\u0438 \u0441\u0435\u0437\u043E\u043D\u0430",
  "m.bp.free2": "\u0415\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0435 \u0438 \u043D\u0435\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u043D\u0438\u044F",
  "m.bp.free3": "\u0414\u043E\u0441\u0442\u0443\u043F \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043C \u0441\u0435\u0437\u043E\u043D\u0430",
  "m.bp.prem1": "\u0412\u0442\u043E\u0440\u0430\u044F \u043B\u0438\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434 \u043D\u0430 \u0432\u0441\u0435\u0445 {n} \u0443\u0440\u043E\u0432\u043D\u044F\u0445",
  "m.bp.prem2": "\u041A\u043E\u0441\u043C\u0435\u0442\u0438\u043A\u0430 \u0441\u0435\u0437\u043E\u043D\u0430: \u043C\u0430\u0441\u043A\u0438, \u0441\u0435\u0442\u044B, \u043E\u043A\u0440\u0430\u0441\u044B, \u044D\u043C\u043E\u0446\u0438\u0438",
  "m.bp.prem3": "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 JC \u043D\u0430 \u0447\u0430\u0441\u0442\u0438 \u0443\u0440\u043E\u0432\u043D\u0435\u0439",
  "m.bp.prem4": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C-\u0432\u044B\u0437\u043E\u0432\u044B \u043D\u0435\u0434\u0435\u043B\u0438",
  "m.bp.bundle": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C + 20 \u0443\u0440\u043E\u0432\u043D\u0435\u0439",
  "m.bp.bundle1": "\u0412\u0441\u0451 \u0438\u0437 \u043F\u0440\u0435\u043C\u0438\u0443\u043C-\u043F\u0440\u043E\u043F\u0443\u0441\u043A\u0430",
  "m.bp.bundle2": "\u0421\u0440\u0430\u0437\u0443 +20 \u0443\u0440\u043E\u0432\u043D\u0435\u0439 \u043A \u0442\u0435\u043A\u0443\u0449\u0435\u043C\u0443",
  "m.bp.bundle3": "\u0412\u044B\u0433\u043E\u0434\u043D\u0435\u0435, \u0447\u0435\u043C \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u044C \u0443\u0440\u043E\u0432\u043D\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E",
  "m.bp.buyExpAbout": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u0434\u043D\u044F\u0442\u044C \u0441\u0440\u0430\u0437\u0443 \u2014 \u043D\u0430\u0433\u0440\u0430\u0434\u044B \u043E\u0431\u0435\u0438\u0445 \u043B\u0438\u043D\u0438\u0439 \u043E\u0442\u043A\u0440\u043E\u044E\u0442\u0441\u044F \u043A\u0430\u043A \u043E\u0431\u044B\u0447\u043D\u043E. \u041E\u0447\u043A\u0438 \u0441\u0435\u0437\u043E\u043D\u0430 \u0437\u0430 \u0437\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u0438 \u044D\u0442\u043E\u043C \u043D\u0435 \u0441\u0433\u043E\u0440\u0430\u044E\u0442.",
  "m.bp.levelsWord": "\u0443\u0440\u043E\u0432\u043D\u044F \u043A \u0442\u0435\u043A\u0443\u0449\u0435\u043C\u0443",
  "m.bp.toLevel": "\u0421\u0442\u0430\u043D\u0435\u0442 {n}-\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C",
  "m.bp.spGain": "\u0417\u0430\u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F {n} SP",
  "m.bp.unlockRewards": "\u041E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u043D\u0430\u0433\u0440\u0430\u0434: {n}",
  // — анимации —
  "m.an.kicker": "\u041E\u0442\u044B\u0433\u0440\u044B\u0448",
  "m.an.title": "\u0410\u043D\u0438\u043C\u0430\u0446\u0438\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "m.an.of": "\u043F\u043E\u043A\u0430\u0437\u0430\u043D\u043E {n} \u0438\u0437 {all}",
  "m.an.find": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u0438",
  "m.an.stop": "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
  "m.an.space": "\u041F\u0440\u043E\u0431\u0435\u043B",
  "m.an.play": "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C",
  "m.an.fav": "\u0418\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435",
  "m.an.shop": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  "m.an.none": "\u0412 \u044D\u0442\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u043F\u0443\u0441\u0442\u043E",
  "m.an.more": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0451 {n}",
  "m.an.shopHint": "\u041F\u043B\u0430\u0442\u043D\u0430\u044F \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0435\u0442\u0441\u044F \u043E\u0434\u0438\u043D \u0440\u0430\u0437 \u0438 \u043E\u0441\u0442\u0430\u0451\u0442\u0441\u044F \u043D\u0430\u0432\u0441\u0435\u0433\u0434\u0430.",
  // — магазин —
  "m.sh.kicker": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  "m.sh.owned": "\u0423 \u0432\u0430\u0441: {n}",
  "m.sh.open": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C",
  "m.sh.content": "\u0427\u0442\u043E \u0435\u0441\u0442\u044C \u0432 \u043A\u0435\u0439\u0441\u0435",
  "m.sh.rolling": "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0435\u043C \u043A\u0435\u0439\u0441",
  "m.sh.gotIt": "\u0412\u0430\u043C \u0432\u044B\u043F\u0430\u043B\u043E",
  "m.sh.take": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C",
  "m.sh.sell": "\u041F\u0440\u043E\u0434\u0430\u0442\u044C",
  "m.sh.cases": "\u041A\u0435\u0439\u0441\u044B",
  "m.sh.caseBuy": "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0435\u0439\u0441",
  "m.sh.count": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u0435\u0439\u0441\u043E\u0432",
  "m.sh.clothes": "\u041E\u0434\u0435\u0436\u0434\u0430",
  "m.sh.slot": "\u0421\u043B\u043E\u0442",
  "m.sh.tryOn": "\u041F\u0440\u0438\u043C\u0435\u0440\u0438\u0442\u044C",
  "m.sh.cars": "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D",
  "m.sh.color": "\u0426\u0432\u0435\u0442",
  "m.sh.speed": "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C",
  "m.sh.seats": "\u041C\u0435\u0441\u0442",
  "m.sh.currency": "\u0418\u0433\u0440\u043E\u0432\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430",
  "m.sh.exchange": "\u041E\u0431\u043C\u0435\u043D\u044F\u0442\u044C",
  "m.sh.premium": "\u041F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438",
  "m.sh.term": "\u0421\u0440\u043E\u043A",
  "m.sh.premDays": "\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 30 \u0434\u043D\u0435\u0439",
  "m.sh.services": "\u0423\u0441\u043B\u0443\u0433\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "m.sh.starter": "\u0421\u0442\u0430\u0440\u0442\u043E\u0432\u044B\u0435 \u043D\u0430\u0431\u043E\u0440\u044B",
  "m.sh.discount": "\u0421\u043A\u0438\u0434\u043A\u0430 {n}%",
  "m.sh.toAccount": "\u043D\u0430 \u0438\u0433\u0440\u043E\u0432\u043E\u0439 \u0441\u0447\u0451\u0442",
  "m.sh.newName": "\u0418\u043C\u044F \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u044F",
  // — слоты одежды —
  "m.slot.mask": "\u041C\u0430\u0441\u043A\u0438",
  "m.slot.hat": "\u0413\u043E\u043B\u043E\u0432\u043D\u044B\u0435 \u0443\u0431\u043E\u0440\u044B",
  "m.slot.glasses": "\u041E\u0447\u043A\u0438",
  "m.slot.acc": "\u0410\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B",
  "m.slot.top": "\u0412\u0435\u0440\u0445\u043D\u044F\u044F \u043E\u0434\u0435\u0436\u0434\u0430",
  "m.slot.armor": "\u0411\u0440\u043E\u043D\u0435\u0436\u0438\u043B\u0435\u0442\u044B",
  "m.slot.under": "\u041D\u0438\u0436\u043D\u044F\u044F \u043E\u0434\u0435\u0436\u0434\u0430",
  "m.slot.legs": "\u0428\u0442\u0430\u043D\u044B",
  "m.slot.shoes": "\u041E\u0431\u0443\u0432\u044C",
  "m.slot.bag": "\u0421\u0443\u043C\u043A\u0438",
  "m.slot.watch": "\u0427\u0430\u0441\u044B",
  "m.slot.gloves": "\u041F\u0435\u0440\u0447\u0430\u0442\u043A\u0438",
  // — игры —
  "m.wh.kicker": "\u041A\u0430\u0437\u0438\u043D\u043E",
  "m.wh.title": "\u041A\u043E\u043B\u0435\u0441\u043E \u0443\u0434\u0430\u0447\u0438",
  "m.wh.bet": "\u0421\u0442\u0430\u0432\u043A\u0430",
  "m.wh.place": "\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
  "m.wh.round": "\u0420\u0430\u0443\u043D\u0434",
  "m.wh.spinning": "\u041A\u0440\u0443\u0442\u0438\u0442\u0441\u044F\u2026",
  "m.wh.waiting": "\u041F\u0440\u0438\u0451\u043C \u0441\u0442\u0430\u0432\u043E\u043A",
  "m.wh.history": "\u0418\u0441\u0442\u043E\u0440\u0438\u044F",
  "m.wh.players": "\u0418\u0433\u0440\u043E\u043A\u0438",
  "m.wh.bank": "\u0411\u0430\u043D\u043A",
  "m.wh.noBets": "\u0421\u0442\u0430\u0432\u043E\u043A \u043D\u0435\u0442",
  "m.sp.kicker": "\u041A\u0430\u0437\u0438\u043D\u043E",
  "m.sp.title": "\u0421\u0430\u043F\u0451\u0440",
  "m.sp.play": "\u0418\u0433\u0440\u0430\u0442\u044C",
  "m.sp.cashout": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C",
  "m.sp.win": "\u0412\u044B\u0438\u0433\u0440\u044B\u0448",
  "m.sp.boom": "\u041C\u0438\u043D\u0430!",
  "m.sp.rule": "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0439\u0442\u0435 \u043F\u043E \u044F\u0447\u0435\u0439\u043A\u0435 \u0432 \u0440\u044F\u0434\u0443. \u041A\u0430\u0436\u0434\u044B\u0439 \u0440\u044F\u0434 \u043F\u043E\u0434\u043D\u0438\u043C\u0430\u0435\u0442 \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442 \u2014 \u0437\u0430\u0431\u0440\u0430\u0442\u044C \u043C\u043E\u0436\u043D\u043E \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442.",
  "m.sp.row": "\u0420\u044F\u0434",
  // — общество —
  "m.bz.kicker": "\u041F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F",
  "m.bz.title": "\u0411\u0438\u0437\u043D\u0435\u0441",
  "m.bz.treasury": "\u041A\u0430\u0441\u0441\u0430",
  "m.bz.share": "\u0414\u043E\u043B\u044F",
  "m.bz.manager": "\u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439",
  "m.bz.owner": "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446",
  "m.bz.partner": "\u041F\u0430\u0440\u0442\u043D\u0451\u0440",
  "m.bz.noManager": "\u041D\u0435 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D",
  "m.bz.none": "\u0411\u0438\u0437\u043D\u0435\u0441\u0430 \u043D\u0435\u0442",
  "m.or.kicker": "\u0424\u0440\u0430\u043A\u0446\u0438\u044F",
  "m.or.title": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "m.or.rank": "\u0420\u0430\u043D\u0433",
  "m.or.members": "\u0421\u043E\u0441\u0442\u0430\u0432",
  "m.or.turf": "\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
  "m.or.control": "\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C",
  "m.or.none": "\u0412\u044B \u043D\u0435 \u0441\u043E\u0441\u0442\u043E\u0438\u0442\u0435 \u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
  "m.or.noTurf": "\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0439 \u043F\u043E\u0434 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0435\u043C \u043D\u0435\u0442",
  "m.ac.kicker": "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441",
  "m.ac.title": "\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F",
  "m.ac.streak": "\u0421\u0435\u0440\u0438\u044F \u0432\u0445\u043E\u0434\u043E\u0432",
  "m.ac.days": "\u0434\u043D.",
  "m.ac.milestones": "\u0412\u0435\u0445\u0438",
  "m.ac.next": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F",
  "m.ac.claimed": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
  "m.ac.none": "\u0412\u0435\u0445 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442",
  // — обращения —
  "m.rp.kicker": "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
  "m.rp.title": "\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
  "m.rp.placeholder": "\u041E\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u043E\u0434\u043D\u0438\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C",
  "m.rp.new": "\u041D\u043E\u0432\u043E\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435",
  "m.rp.send": "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
  "m.rp.write": "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u2026",
  "m.rp.pick": "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0441\u043B\u0435\u0432\u0430",
  "m.rp.none": "\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439 \u043D\u0435\u0442",
  "m.rp.open": "\u041E\u0442\u043A\u0440\u044B\u0442\u043E",
  "m.rp.taken": "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
  "m.rp.closed": "\u0417\u0430\u043A\u0440\u044B\u0442\u043E",
  "m.rp.answered": "Есть ответ",
  "m.rp.waiting": "Ждём ответа администрации",
  "m.rp.admin": "Администрация",
  "m.rp.refresh": "Обновить",
  // — правила —
  "m.rl.kicker": "\u0420\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442",
  "m.rl.title": "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
  "m.rl.sections": "\u0420\u0430\u0437\u0434\u0435\u043B\u043E\u0432",
  "m.rl.find": "\u0418\u0441\u043A\u0430\u0442\u044C \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u043F\u0440\u0430\u0432\u0438\u043B",
  // — настройки —
  "m.se.kicker": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  "m.se.title": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0438\u0433\u0440\u044B",
  "m.se.main": "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u0436",
  "m.se.hud": "\u0418\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441",
  "m.se.chat": "\u0427\u0430\u0442",
  "m.se.sound": "\u0417\u0432\u0443\u043A",
  "m.se.crosshair": "\u041F\u0440\u0438\u0446\u0435\u043B",
  "m.se.account": "\u0410\u043A\u043A\u0430\u0443\u043D\u0442",
  "m.se.binds": "\u041A\u043B\u0430\u0432\u0438\u0448\u0438",
  "m.se.pressKey": "Нажмите клавишу…",
  "m.se.language": "\u042F\u0437\u044B\u043A \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430",
  "m.se.langHint": "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0435 \u0438 \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u043A\u043E \u0432\u0441\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0430\u043C.",
  "m.se.reset": "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C",
  "m.se.bindHint": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 \u0441\u043F\u0440\u0430\u0432\u0430, \u0437\u0430\u0442\u0435\u043C \u043D\u0443\u0436\u043D\u0443\u044E \u043A\u043D\u043E\u043F\u043A\u0443 \u043D\u0430 \u043A\u043B\u0430\u0432\u0438\u0430\u0442\u0443\u0440\u0435.",
  "m.se.cat.all": "\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435",
  "m.se.cat.vehicle": "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
  "m.se.cat.fast": "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F",
  "m.se.cat.fraction": "\u0424\u0440\u0430\u043A\u0446\u0438\u043E\u043D\u043D\u044B\u0435",
  "m.se.cat.other": "\u0420\u0430\u0437\u043D\u043E\u0435",
  "m.se.session": "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0441\u0435\u0441\u0441\u0438\u0438",
  "m.se.sessionHint": "\u0412\u0445\u043E\u0434 \u0431\u0435\u0437 \u043F\u0430\u0440\u043E\u043B\u044F \u0441 \u044D\u0442\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430.",
  "m.se.email": "\u041F\u043E\u0447\u0442\u0430 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
  "m.se.emailHint": "\u041D\u0443\u0436\u043D\u0430 \u0434\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
};
const EN = {
  "m.g.dossier": "Dossier",
  "m.g.property": "Property",
  "m.g.tasks": "Tasks",
  "m.g.pass": "Battle pass",
  "m.g.anims": "Emotes",
  "m.g.shop": "Store",
  "m.g.games": "Games",
  "m.g.society": "Society",
  "m.g.service": "Service",
  "m.overview": "Overview",
  "m.stats": "Statistics",
  "m.skills": "Skills",
  "m.vehicles": "Vehicles",
  "m.storage": "Storage",
  "m.estate": "Real estate",
  "m.quests": "Quests",
  "m.dailies": "Daily",
  "m.bonuses": "Bonuses",
  "m.battlepass": "Battle pass",
  "m.anims": "Emotes",
  "m.cases": "Cases",
  "m.clothing": "Clothing",
  "m.shopcars": "Dealership",
  "m.currency": "Currency",
  "m.premium": "Premium",
  "m.services": "Services",
  "m.starter": "Starter kits",
  "m.wheel": "Wheel",
  "m.sapper": "Minesweeper",
  "m.business": "Business",
  "m.organization": "Organization",
  "m.achievements": "Achievements",
  "m.reports": "Support",
  "m.settings": "Settings",
  "m.rules": "Rules",
  "m.close": "Close \xB7 F2",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.close": "Close",
  "m.ov.faction": "Organization",
  "m.balance": "Balance",
  "m.empty": "Nothing here yet",
  "m.buy": "Buy",
  "m.take": "Claim",
  "m.taken": "Claimed",
  "m.skipped": "Missed",
  "m.locked": "Locked",
  "m.price": "Price",
  "m.total": "Total",
  "m.of": "of",
  "m.notEnough": "Not enough JC",
  "m.soon": "Soon",
  "m.all": "All",
  "m.search": "Search",
  "m.nothingFound": "Nothing found",
  "m.ov.kicker": "Dossier",
  "m.ov.title": "Character overview",
  "m.ov.cash": "Cash",
  "m.ov.bank": "Bank",
  "m.ov.age": "Age",
  "m.ov.gender": "Gender",
  "m.ov.male": "Male",
  "m.ov.female": "Female",
  "m.ov.job": "Job",
  "m.ov.wedding": "Marital status",
  "m.ov.single": "Single",
  "m.ov.fraction": "Organization",
  "m.ov.family": "Family",
  "m.ov.rank": "Rank",
  "m.ov.vip": "Premium status",
  "m.ov.vipUntil": "Valid until",
  "m.ov.passport": "Passport",
  "m.ov.phone": "Phone",
  "m.ov.noSim": "No SIM card",
  "m.ov.account": "Account number",
  "m.ov.docs": "Documents",
  "m.ov.status": "Standing",
  "m.ov.years": "years",
  "m.ov.level": "Level",
  "m.ov.respect": "Respect",
  "m.ov.next": "What is next",
  "m.ov.watched": "Under review",
  "m.ov.clean": "Record is clean",
  "m.st.kicker": "Record card",
  "m.st.title": "Statistics",
  "m.st.registered": "Playing since",
  "m.st.playtime": "Time played",
  "m.st.today": "Day",
  "m.st.month": "Month",
  "m.st.total": "Total",
  "m.st.warns": "Warnings",
  "m.st.warnsActive": "active of 3",
  "m.st.licenses": "Licenses",
  "m.st.has": "Issued",
  "m.st.hasNot": "None",
  "m.st.licOf": "{n} of {all} issued",
  "m.sk.kicker": "Professions",
  "m.sk.title": "Skills",
  "m.sk.rank": "rank",
  "m.sk.progress": "Progress",
  "m.sk.maxed": "Maxed",
  "m.sk.none": "No skills yet \u2014 take a job first",
  "m.veh.kicker": "Garage",
  "m.veh.title": "My vehicles",
  "m.veh.plate": "Plate",
  "m.veh.fuel": "Fuel",
  "m.veh.state": "Condition",
  "m.veh.mileage": "Mileage",
  "m.veh.parking": "Parking",
  "m.veh.garage": "In garage",
  "m.veh.street": "On street",
  "m.veh.impound": "Impounded",
  "m.veh.none": "No vehicles",
  "m.veh.locate": "Show on map",
  "m.stg.kicker": "Character storage",
  "m.stg.title": "Storage",
  "m.stg.take": "Move to inventory",
  "m.stg.slots": "slots used",
  "m.stg.none": "Storage is empty",
  "m.stg.count": "pcs",
  "m.stg.pickupHint": "Items are handed out at the storage desk \u2014 drive up to it.",
  "m.stg.route": "Show storage on map",
  "m.stg.point": "Personal storage",
  "m.veh.evac": "Tow to garage",
  "m.veh.impound": "Pay impound fee",
  "m.veh.keys": "Share keys",
  "m.es.kicker": "Holdings",
  "m.es.title": "Real estate",
  "m.es.house": "House",
  "m.es.biz": "Business",
  "m.es.warehouse": "Warehouse",
  "m.es.safe": "In safe",
  "m.es.income": "Income per hour",
  "m.es.slots": "Vehicle slots",
  "m.es.tax": "Tax due",
  "m.es.none": "No property",
  "m.es.addr": "Address",
  "m.ac.account": "Account",
  "m.ac.level": "Level",
  "m.ac.exp": "Experience",
  "m.ac.daysOn": "On server",
  "m.ac.since": "Member since",
  "m.ac.time": "Time played",
  "m.ac.today": "Today",
  "m.ac.month": "This month",
  "m.ac.total": "Total",
  "m.ac.wealth": "Assets",
  "m.ac.jc": "JC balance",
  "m.ac.cars": "Vehicles",
  "m.ac.house": "House",
  "m.ac.biz": "Businesses",
  "m.ac.status": "Status",
  "m.ac.vip": "Privilege",
  "m.ac.until": "until",
  "m.ac.sub": "Subscription",
  "m.ac.active": "active",
  "m.ac.warns": "Warnings",
  "m.ac.wanted": "Wanted",
  "m.ac.org": "Organization",
  "m.ac.wedding": "Marriage",
  "m.ac.no": "none",
  "m.q.kicker": "Story",
  "m.q.title": "Quests",
  "m.q.stage": "Stage",
  "m.q.route": "Set route",
  "m.q.accept": "Accept quest",
  "m.q.reward": "Reward",
  "m.q.none": "No active quests",
  "m.q.active": "Active",
  "m.q.next": "Next up",
  "m.q.goals": "Goals",
  "m.q.money": "Money",
  "m.q.items": "Reward items",
  "m.d.kicker": "Daily login",
  "m.d.title": "Daily rewards",
  "m.d.day": "Day {n}",
  "m.d.week": "Weekly reward",
  "m.d.in": "In",
  "m.d.streak": "Day streak",
  "m.b.kicker": "Top-up bonuses",
  "m.b.title": "Bonuses",
  "m.b.progress": "{a} of {b} JC topped up",
  "m.bp.kicker": "Season",
  "m.bp.title": "Battle pass",
  "m.bp.level": "Level {n}",
  "m.bp.free": "Free",
  "m.bp.prem": "Premium",
  "m.bp.buyPrem": "Buy premium",
  "m.bp.premOn": "Premium active",
  "m.bp.daysLeft": "{n} days left",
  "m.bp.track": "Reward track",
  "m.bp.buyExp": "Buy levels",
  "m.bp.tasks": "Season tasks",
  "m.bp.daily": "Daily",
  "m.bp.weekly": "Weekly",
  "m.bp.season": "Season",
  "m.bp.done": "Done",
  "m.bp.progress": "Progress",
  "m.bp.takeAll": "Claim all",
  "m.bp.levels": "Levels {a}\u2013{b}",
  "m.bp.toCurrent": "To my level",
  "m.bp.week": "Week",
  "m.bp.weekN": "Week {n}",
  "m.bp.now": "Running now",
  "m.bp.tiers": "Levels done",
  "m.bp.spTotal": "Total SP",
  "m.bp.noReward": "No reward",
  "m.bp.noTasks": "No tasks yet",
  "m.bp.premAbout": "The free line is open to everyone. Premium adds a second reward on every level \u2014 bought once for the whole season.",
  "m.bp.starterPass": "Starter pass",
  "m.bp.premPass": "Premium pass",
  "m.bp.yours": "You have it",
  "m.bp.included": "Included in premium",
  "m.bp.free1": "Top reward line for season points",
  "m.bp.free2": "Daily and weekly tasks",
  "m.bp.free3": "Access to every season event",
  "m.bp.prem1": "Second reward line on all {n} levels",
  "m.bp.prem2": "Season cosmetics: masks, sets, paints, emotes",
  "m.bp.prem3": "JC back on some levels",
  "m.bp.prem4": "Premium weekly challenges",
  "m.bp.bundle": "Premium + 20 levels",
  "m.bp.bundle1": "Everything from the premium pass",
  "m.bp.bundle2": "+20 levels on top of your current one",
  "m.bp.bundle3": "Cheaper than buying levels separately",
  "m.bp.buyExpAbout": "Levels can be raised instantly \u2014 both reward lines unlock as usual and earned season points stay.",
  "m.bp.levelsWord": "levels added",
  "m.bp.toLevel": "You reach level {n}",
  "m.bp.spGain": "{n} SP credited",
  "m.bp.unlockRewards": "Rewards unlocked: {n}",
  "m.an.kicker": "Roleplay",
  "m.an.title": "Character emotes",
  "m.an.of": "showing {n} of {all}",
  "m.an.find": "Emote name",
  "m.an.stop": "Stop",
  "m.an.space": "Space",
  "m.an.play": "Play",
  "m.an.fav": "Favourites",
  "m.an.shop": "Store",
  "m.an.none": "This category is empty",
  "m.an.more": "Show {n} more",
  "m.an.shopHint": "A paid emote is bought once and stays forever.",
  "m.sh.kicker": "Store",
  "m.sh.owned": "You own: {n}",
  "m.sh.open": "Open",
  "m.sh.content": "What is inside",
  "m.sh.rolling": "Opening the case",
  "m.sh.gotIt": "You got",
  "m.sh.take": "Take",
  "m.sh.sell": "Sell",
  "m.sh.cases": "Cases",
  "m.sh.caseBuy": "Buy case",
  "m.sh.count": "How many cases",
  "m.sh.clothes": "Clothing",
  "m.sh.slot": "Slot",
  "m.sh.tryOn": "Try on",
  "m.sh.cars": "Dealership",
  "m.sh.color": "Colour",
  "m.sh.speed": "Top speed",
  "m.sh.seats": "Seats",
  "m.sh.currency": "In-game currency",
  "m.sh.exchange": "Exchange",
  "m.sh.premium": "Privileges",
  "m.sh.term": "Term",
  "m.sh.premDays": "Valid for 30 days",
  "m.sh.services": "Character services",
  "m.sh.starter": "Starter kits",
  "m.sh.discount": "{n}% off",
  "m.sh.toAccount": "to your account",
  "m.sh.newName": "First and last name",
  "m.slot.mask": "Masks",
  "m.slot.hat": "Hats",
  "m.slot.glasses": "Glasses",
  "m.slot.acc": "Accessories",
  "m.slot.top": "Tops",
  "m.slot.armor": "Body armor",
  "m.slot.under": "Undershirts",
  "m.slot.legs": "Pants",
  "m.slot.shoes": "Shoes",
  "m.slot.bag": "Bags",
  "m.slot.watch": "Watches",
  "m.slot.gloves": "Gloves",
  "m.wh.kicker": "Casino",
  "m.wh.title": "Wheel of fortune",
  "m.wh.bet": "Bet",
  "m.wh.place": "Place bet",
  "m.wh.round": "Round",
  "m.wh.spinning": "Spinning\u2026",
  "m.wh.waiting": "Taking bets",
  "m.wh.history": "History",
  "m.wh.players": "Players",
  "m.wh.bank": "Pot",
  "m.wh.noBets": "No bets",
  "m.sp.kicker": "Casino",
  "m.sp.title": "Minesweeper",
  "m.sp.play": "Play",
  "m.sp.cashout": "Cash out",
  "m.sp.win": "Payout",
  "m.sp.boom": "Boom!",
  "m.sp.rule": "Open one cell per row. Every row raises the multiplier \u2014 cash out any time.",
  "m.sp.row": "Row",
  "m.bz.kicker": "Enterprises",
  "m.bz.title": "Business",
  "m.bz.treasury": "Treasury",
  "m.bz.share": "Share",
  "m.bz.manager": "Manager",
  "m.bz.owner": "Owner",
  "m.bz.partner": "Partner",
  "m.bz.noManager": "Not assigned",
  "m.bz.none": "No business",
  "m.or.kicker": "Faction",
  "m.or.title": "Organization",
  "m.or.rank": "Rank",
  "m.or.members": "Roster",
  "m.or.turf": "Turf",
  "m.or.control": "control",
  "m.or.none": "You are not in an organization",
  "m.or.noTurf": "No turf controlled",
  "m.ac.kicker": "Progress",
  "m.ac.title": "Achievements",
  "m.ac.streak": "Login streak",
  "m.ac.days": "d",
  "m.ac.milestones": "Milestones",
  "m.ac.next": "Next",
  "m.ac.claimed": "Claimed",
  "m.ac.none": "No milestones yet",
  "m.rp.kicker": "Support",
  "m.rp.title": "Tickets",
  "m.rp.placeholder": "Describe the issue in one message",
  "m.rp.new": "New ticket",
  "m.rp.send": "Send",
  "m.rp.write": "Write a message\u2026",
  "m.rp.pick": "Pick a ticket on the left",
  "m.rp.none": "No tickets",
  "m.rp.open": "Open",
  "m.rp.answered": "Answered",
  "m.rp.waiting": "Waiting for a reply",
  "m.rp.admin": "Administration",
  "m.rp.refresh": "Refresh",
  "m.rp.taken": "In progress",
  "m.rp.closed": "Closed",
  "m.rl.kicker": "Regulations",
  "m.rl.title": "Server rules",
  "m.rl.sections": "Sections",
  "m.rl.find": "Search the rules",
  "m.se.kicker": "Settings",
  "m.se.title": "Game settings",
  "m.se.main": "Character",
  "m.se.hud": "Interface",
  "m.se.chat": "Chat",
  "m.se.sound": "Sound",
  "m.se.crosshair": "Crosshair",
  "m.se.account": "Account",
  "m.se.binds": "Key binds",
  "m.se.pressKey": "Press a key…",
  "m.se.language": "Interface language",
  "m.se.langHint": "Saved on the account and applied to every screen.",
  "m.se.reset": "Reset",
  "m.se.bindHint": "Click a key on the right, then press the new button.",
  "m.se.cat.all": "General",
  "m.se.cat.vehicle": "Vehicle",
  "m.se.cat.fast": "Quick access",
  "m.se.cat.fraction": "Faction",
  "m.se.cat.other": "Other",
  "m.se.session": "Keep me signed in",
  "m.se.sessionHint": "Sign in without a password on this computer.",
  "m.se.email": "Account email",
  "m.se.emailHint": "Needed to restore access."
};
Object.assign(ru, RU);
Object.assign(en, EN);
